export default __webpack_public_path__ + "static/28277-12c7fec9ca6020b37b261db56fdc5917.jpg";